import { render } from "./ZonePricingForCustomerAddOrUpdateTable.html?vue&type=template&id=e5d13fdc&scoped=true"
import script from "./ZonePricingForCustomerAddOrUpdateTable.js?vue&type=script&lang=js"
export * from "./ZonePricingForCustomerAddOrUpdateTable.js?vue&type=script&lang=js"

import "./ZonePricingForCustomerAddOrUpdateTable.css?vue&type=style&index=0&id=e5d13fdc&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-customer-portal/src/ST.PetroNetworkCustomer.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5d13fdc"]])

export default __exports__